/* eslint-disable */

export const resources = state => state.resources;
export const totalResources = state => state.totalResources;
export const currentPage = state => state.currentPage;
export const deposit = state => state.deposit;
export const loadingData = state => state.loadingData;
export const initialDate = state => state.initialDate;
export const finalDate = state => state.finalDate;
export const status = state => state.status;
export const limitOptions = state => state.limitOptions;
export const limit = state => state.limit;
export const page = state => state.page;
export const ordination = state => state.ordination;
export const subtotal = state => state.subtotal;
export const showFilters = state => state.showFilters;
export const filterVisible = state => state.filterVisible;
export const filterParams = state => state.filterParams;
export const filtersInitialDate = state => state.filtersInitialDate;
export const filtersFinalDate = state => state.filtersFinalDate;
export const filtersDepositInitialDate = state => state.filtersDepositInitialDate;
export const filtersDepositFinalDate = state => state.filtersDepositFinalDate;
export const filtersCardBrand = state => state.filtersCardBrand;
export const filtersOperation = state => state.filtersOperation;
export const filtersOrdination = state => state.filtersOrdination;
export const filtersStatus = state => state.filtersStatus;
export const filtersPartner = state => state.filtersPartner;

export const filter = state => {
  const filters = {
    page: state.currentPage || 1,
    limit: state.limit || 10,
    filterrific: {
      with_due_on_between: {
        start_at: state.filtersInitialDate,
        end_at: state.filtersFinalDate
      },
      credit_card_brand: state.filtersCardBrand,
      status: state.filtersStatus,
      sorted_by: state.filtersOrdination,
      with_partner: state.filtersPartner
    }
  };
  return filters;
};

export const pagination = state => {
  const page_set = {
    page: state.currentPage,
    rowsPerPage: state.limitOptions,
    totalItems: state.totalResources
  };
  return page_set;
};
